import {MenuCategoryModel} from './menu-category.model';

export class MenuSectionModel {
  id: number;
  hotel_id: number;
  menu_area_id: number;
  catalogue_active: boolean;
  timetable_and_reservation_active: boolean;
  title: string;
  show: boolean;
  menu_categories: MenuCategoryModel[];

  constructor(id = 0,
              hotel_id = 0,
              menu_area_id = 0,
              catalogue_active = false,
              timetable_and_reservation_active = false,
              title = '',
              show = false) {
    this.id = id;
    this.hotel_id = hotel_id;
    this.menu_area_id = menu_area_id;
    this.catalogue_active = catalogue_active;
    this.timetable_and_reservation_active = timetable_and_reservation_active;
    this.title = title;
    this.show = show;
  }
}
